<template>
    <div class="container">
        <h1>Configure Schedules</h1>
        <b-tabs position="is-centered" class="block" v-model="activeTab">
            <b-tab-item label="List">
                <p>list of schedules</p>
            </b-tab-item>
            <b-tab-item label="Create schedule">
                <div class="container has-text-left">
                    <p>form create</p>
                </div>
            </b-tab-item>
        </b-tabs>
    </div>
</template>

<script>
    import BTabItem from "buefy/src/components/tabs/TabItem";

  export default {
    name: "screenconfigureschedules",
    components: {
      BTabItem
    },
    data() {
      return {
        activeTab: 0
      };
    },
    computed: {
    },
    methods: {

    },
    mounted() {

    }
  }
</script>

<style scoped>
h1 {
    font-size: 1.5rem;
    font-weight: bold;
    margin-top: 0.75rem;
    margin-bottom: 0.75rem;
}

    .container {
        margin-top: 1rem;
    }
</style>